/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import Grid from "components/Grid/GridContainer";
import Col from "components/Grid/GridItem";

import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSSelect2 from "components/Forms/TSSelect2";
import TSText from "components/Forms/TSText";
import TSRadio from "components/Forms/TSRadio";
import { Collapse, Modal, ModalBody } from "reactstrap";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import TSUser from "components/Forms/TSUser";
import axios from "axios";
import { authHeader } from "_helpers";


import {
    Input,
    Label,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

import "react-datetime/css/react-datetime.css"
import "./custom-style.css";

import styled from "styled-components";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const _color = [{ id: 1, forecolor: '#3788d8' }, { id: 2, forecolor: '#0E6251' }, { id: 3, forecolor: '#9A7D0A' }, { id: 4, forecolor: '#8E44AD' }, { id: 5, forecolor: '#E67E22' }]

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

const Home = (props) => {
    const [isHR, setIsHR] = useState(false);
    const [isNurse, setIsNurse] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);


    var moment = require('moment');
    require('moment/locale/th');


    useEffect(() => {

        axios({
            method: 'post',
            url: "/api/v1/currentdate"
        })
            .then(
                result => {
                    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
                    const _isHR = currentUser.userDepartment.filter(u => u.departmentKey == 105 || u.departmentKey == 108).length > 0;
                    const _isAdmin = currentUser.userDepartment.filter(u => u.departmentKey == 108).length > 0;
                    const _isNurse = currentUser.userDepartment.some(u => u.department?.missionKey === 3);
        
                    setIsHR(_isHR);
                    setIsAdmin(_isAdmin);
                    setIsNurse(_isNurse);
                },
                error => { console.log(error); }
            );
    }, []);


    const classes = useStyles();
    const classes2 = useStyles2();

    return (

        <div>
            <Grid>
                {[
                    //{ icon: "fas fa-map", title: "Custom FloorMap", color: "primary", url: "/home/custom-floormap" },
                    //{ icon: "fas fa-hospital", title: "Queue Digital Twin", color: "primary", url: "/home/queue-twin" },
                    { icon: "fas fa-hand-paper", title: "ระบบจองห้องประชุม", color: "primary", url: "/meeting" },
                    { icon: "fas fa-users", title: "ระบบลา", color: "warning", url: "/leave" },
                    { icon: "fas fa-warehouse", title: "ระบบครุภัณฑ์", color: "success", url: "/asset", isVisible: isAdmin },
                    { icon: "fas fa-users-cog", title: "ระบบทรัพยากรบุคคล", color: "warning", url: "/hr", isVisible: isHR },
                    { icon: "fas fa-cogs", title: "ระบบบริการ", color: "#c41cc9", url: "/servicesystem" },
                    { icon: "fas fa-file-signature", title: "ระบบใบยินยอม", color: "#EC1D8B9C", url: "/consent", isVisible: (isAdmin || isNurse) },
                    { icon: "fas fa-chart-bar", title: "ระบบ Datacenter", color: "info", url: "/datacenter" },
                    { icon: "fas fa-hotel", title: "ระบบหอพัก/ห้องพัก", color: "#2e7d32", url: "/dormitory" },
                    { icon: "fas fa-user-graduate", title: "ระบบแพทย์และนักศึกษาฝึกงาน", color: "#0097a7", url: "/trainee" },
                    { icon: "fas fa-info-circle", title: "ระบบ Intranet", color: "#5e87b0", url: "http://intranet.trangskin.go.th" },
                    { icon: "fas fa-qrcode", title: "สร้าง QRCode", color: "#000000", url: "https://ops-service.moph.go.th" },
                    { icon: "fas fa-file-signature", title: "ลงนามคำรับรอง ฯ รองผู้อำนวยการ", color: "#4529ff", url: "/signature" },
                    { icon: "fas fa-signature", title: "ลงนามคำรับรอง ฯ หัวหน้ากลุ่มงาน", color: "#b85f5f", url: "/subsignature" },
                    //{icon: "fas fa-signature", title: "ระบบจองรถ", color: "#b85f5f", url: "/vehicle"},
                    { icon: "fas fa-money-bill-wave", title: "การเงินและบัญชี", color: "#009900", url: "/finance" },
                    { icon: "fas fa-file-invoice-dollar", title: "สลิปเงินเดือน", color: "#2563eb", url: "/finance/slip" },
                    //{ icon: "fas fa-bullseye", title: "ระบบประเมิน KPI", color: "info", url: "/kpi" },
                    { icon: "fas fa-exclamation-triangle", title: "ระบบความเสี่ยงใหม่", color: "red", url: "https://skt.thai-nrls.org" },
                    { icon: "fas fa-book", title: "ขอใช้บริการวิเคราะห์ข้อมูลงานวิจัย", color: "#c41cc9", url: "/data-analysis" },

                ].map((card, key) => {
                    if (card.isVisible == undefined || card.isVisible)
                        return (

                            <Col xs={12} sm={4} md={4} lg={3} xl={2} key={key}>
                                <a href={card.url}>
                                    <Card style={{ height: '110px' }}>
                                        <CardHeader stats icon>
                                            <CardIcon color={card.color} style={{ float: 'left', padding: '15px', marginTop: '-20px', marginRight: '15px', borderRadius: '6px', backgroundColor: card.color }}>
                                                <i className={card.icon + " fa-2x"}></i>
                                            </CardIcon>
                                            <p className={classes2.cardCategory}></p>
                                            <h4 className={classes2.cardTitle}>
                                                {card.title}
                                            </h4>
                                        </CardHeader>
                                        <CardBody>
                                        </CardBody>
                                    </Card>
                                </a>

                            </Col>
                        );
                    else
                        return null;
                })}
            </Grid>
        </div>
    );
}



export default Home;
